import React from 'react';
import PropTypes from 'prop-types';
import cond from 'lodash/cond';
import styled from 'styled-components';
import { SuiModalContent } from '@splashthat/sui';
import { useSelector, useDispatch } from 'react-redux';

import FormUsageView from 'common/components/FormLibrary/FormUsage/FormUsageView';
import { getFormLibraryFormId } from 'common/entities/form/selectors';
import { SAVE_FORM_COMPONENT } from './ScaledFormSaveModal';
import ScaledFormsConfirmationContent from './ScaledFormsConfirmationContent';
import ScaledFormsSaveContent from './ScaledFormSaveContent';
import { setEventThemeCount } from '../../actions/formLibrary';

const SAVE_AS_COPY_CONFIRMATION = 'saveAsCopyConfirmation';
const UPDATE_EXISTING_CONFIRMATION = 'updateExistingConfirmation';
const LIST_THEMES_EVENTS = 'themesEventsList';

export const ModalContent = styled(SuiModalContent)`
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    height: 100%;
`;

const ScaledFormsModalContent = ({
    shownModalContent,
    setShownModalContent,
    themeCount,
    eventCount,
    formName,
    onChangeTitle,
    setSaveMethod,
    saveMethod,
    savedFormName,
    formId,
}) => {
    const formLibraryFormId = useSelector((state) => getFormLibraryFormId(state, formId));
    const dispatch = useDispatch();

    const renderSaveContent = () => (
        <ScaledFormsSaveContent
            eventCount={eventCount}
            themeCount={themeCount}
            formName={formName}
            onChangeTitle={onChangeTitle}
            setShownModalContent={setShownModalContent}
            setSaveMethod={setSaveMethod}
            saveMethod={saveMethod}
            savedFormName={savedFormName}
        />
    );

    const renderUpdateExistingConfirmationModal = () => (
        <ScaledFormsConfirmationContent
            shownModalContent={shownModalContent}
            themeCount={themeCount}
            eventCount={eventCount}
        />
    );

    const renderSaveAsCopyConfirmationModal = () => (
        <ScaledFormsConfirmationContent shownModalContent={shownModalContent} />
    );

    const renderThemesEventsList = () => (
        <FormUsageView
            formName={savedFormName}
            formLibraryFormId={formLibraryFormId}
            backToSave={() => setShownModalContent(SAVE_FORM_COMPONENT)}
            onFetchedData={(themesCount, eventsCount) =>
                dispatch(
                    setEventThemeCount({
                        themeCount: themesCount,
                        eventCount: eventsCount,
                    }),
                )
            }
        />
    );

    return (
        <ModalContent>
            {cond([
                [() => shownModalContent === LIST_THEMES_EVENTS, renderThemesEventsList],
                [() => shownModalContent === SAVE_AS_COPY_CONFIRMATION, renderSaveAsCopyConfirmationModal],
                [() => shownModalContent === UPDATE_EXISTING_CONFIRMATION, renderUpdateExistingConfirmationModal],
                [() => true, renderSaveContent],
            ])()}
        </ModalContent>
    );
};

ScaledFormsModalContent.propTypes = {
    shownModalContent: PropTypes.string.isRequired,
    setShownModalContent: PropTypes.func.isRequired,
    themeCount: PropTypes.number,
    eventCount: PropTypes.number,
    formName: PropTypes.string.isRequired,
    onChangeTitle: PropTypes.func.isRequired,
    setSaveMethod: PropTypes.func.isRequired,
    saveMethod: PropTypes.string.isRequired,
    savedFormName: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
};

ScaledFormsModalContent.defaultProps = {
    isLoading: false,
    themeCount: null,
    eventCount: null,
};

export default ScaledFormsModalContent;
